<!--This component is used to display the editor with name, templateType and language dropdown with pageList card-->
<form [formGroup]="templateForm"  (ngSubmit)="saveTemplate()" class="{{editorClass}}">
<ion-grid>
  <ion-row>
    <ion-col size="4">
      <ion-item lines='none' class="form-inputs ion-no-padding">
        <ion-label position="stacked"> {{ 'Name' | translate}} *
        </ion-label>
        <ion-input type='text'
          placeholder="{{ 'Enter_Name' | translate}}" 
          formControlName="name" [(ngModel)]="templateName" required>
        </ion-input>
      </ion-item>
    </ion-col>
    <ion-col size="4">
      <div class="each_div">
        <ion-label position="stacked"> {{ 'Language' | translate}} *</ion-label>
        <ng-select [(ngModel)]="selectedLangauge" placeholder="{{ 'Select_Language' | translate}}" formControlName="langauge" class="placeholder-color"
          (change)="onChangeLanguage($event)" [virtualScroll]='true'>
          <ng-option *ngFor="let language of languages" [value]="language?.value">{{language?.label}}</ng-option>
        </ng-select>
      </div>
    </ion-col>
    <ion-col size="4" class="right-btn">
      <ion-button class="app-btn app-btn-margin margin-top-24" shape="round" fill="outline" color="primary" (click)="exit()">
        {{'Exit'|translate}}
      </ion-button>
      <ion-button class="app-btn app-btn-margin margin-top-24" [disabled]="!isSaveEnabled" shape="round" fill="outline"
        color="primary" type="submit" [disabled]="templateForm.invalid">
       {{'Save'|translate}}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
<div class="flex-container"> 
  <div class="left page-list-card">
    <div class="page-list-card-header">
      {{ 'Page_List' | translate }}
      <img class="add-icon" tooltip="{{ 'Add_New_Page' | translate }}" placement="bottom"
        src="/assets/images/add-circle-outline.svg" (click)="addNewPage()" alt="" />
    </div>
    <div class="page-list-card-content" cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="newPages">
      <div class="flex-container" *ngFor="let page of newPages; let i = index" cdkDrag>
        <div class="left-column page-list-label" [ngClass]="{'active-label': activePageIndex === i}" (click)="setActivePage(i)">
          {{ 'Page ' + (i + 1) }}
        </div>
        <div class="right-column">
          <img class="custom-icon" *ngIf="canRemovePage()" tooltip="{{ 'Remove_Page' | translate }}" placement="bottom"
            [ngClass]="{'active-icon': activePageIndex === i}" src="/assets/images/remove-circle-outline.svg" (click)="removePageConfirmation(i, page)" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="right a4-page">
    <div *ngFor="let editorId of editorIds; let i = index" class="froala-editor">
      <div [id]="editorId" #froalaEditorDiv></div>
    </div>
  </div>
</div>

</form>
